module.exports = __webpack_public_path__ + "static/media/25.9cba5fff.jpg";